<template>
  <div>
    <div class="navbar-custom">
      <div class="container-fluid" style="padding: 0 15px;max-width: 90%;">
        <ul class="list-unstyled topnav-menu float-right mb-0">
             
            <li class="dropdown notification-list topbar-dropdown">
                <a class="nav-link dropdown-toggle waves-effect waves-light" href="mailto:creissupport@cbre.co.jp">
                    <i class="fe-mail noti-icon"></i>
                </a>
            </li>
          
            
            <li class="dropdown d-none d-lg-inline-block topbar-dropdown">
                <a class="nav-link dropdown-toggle arrow-none waves-effect waves-light" data-toggle="dropdown" href="javascript:void(0)"  role="button" aria-haspopup="false"> 
                    <img :src="cur_lan=='en' ?'../assets/images/flags/us.jpg':'../assets/images/flags/japan.jpg'" alt="user-image" height="16">                            </a>
                <div class="dropdown-menu dropdown-menu-right">   
                    <!-- item-->
                    <a href="javascript:void(0);" class="dropdown-item" @click="change_language('en')">
                           
                            <span class="align-middle" style="line-height: 200%;">English &nbsp;&nbsp;</span>
                             <img src="../assets/images/flags/us.jpg" alt="user-image" class="mr-1" height="12"> 
                        </a>
                      
                    <a href="javascript:void(0);" class="dropdown-item" @click="change_language('jp')">
                          <span class="align-middle" style="line-height: 200%;">日本語 &nbsp;&nbsp;</span>
                           <img src="../assets/images/flags/japan.jpg" alt="user-image" class="mr-1" height="12"> 
                        </a>
                    
                    
                </div>
            </li>

            <li class="dropdown notification-list topbar-dropdown">
                <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-toggle="dropdown" href="javascript:void(0)" role="button" aria-haspopup="false">
                    <img src="../assets/images/users/user-1.jpg" alt="user-image" class="rounded-circle">
                    <span class="pro-user-name ml-1">
                        <label id="name">{{username}}</label>  <i class="mdi mdi-chevron-down"></i> 
                    </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right profile-dropdown " v-if="username!=null">
                    <!-- item-->
                
                     <!-- item-->
                    <a href="/userAdd" class="dropdown-item notify-item" v-if="is_adduser && cbredataUser==0">
                        <i class="fe-user"></i>
                        <span> <div class="lang" v-html="lan.step3"></div></span>
                    </a> 
                    <a href="/userProfile" class="dropdown-item notify-item" v-if="is_adduser &&  cbredataUser==0">
                        <i class="fe-user"></i>
                        <span> <div class="lang" v-html="lan.user_profile"></div></span>
                    </a> 
                    <a href="/userApply" class="dropdown-item notify-item" v-if="show_btn">
                        <i class="fe-user"></i>
                        <span> <div class="lang" v-html="lan.user_apply"></div></span>
                    </a>    
                    <!-- item-->
                    <a href="javascript:void(0)" @click="isPopupForgotPassword=1" class="dropdown-item notify-item"  v-if="cbredataUser==0" >
                        <i class="fe-user"></i>
                        <span> <div class="lang" v-html="lan.edit_password"></div></span>
                    </a>   
                   <!-- <div class="dropdown-divider">
                    </div>  -->  
                    <!-- item-->
                    <a href="javascript:voild(0)" class="dropdown-item notify-item" @click="logout()">
                        <i class="fe-log-out"></i>
                        <span><div class="lang" v-html="lan.logout"></div></span>
                    </a>    
                </div>
            </li>    
             
        </ul>

        <!-- LOGO -->
        <div class="logo-box">
            <a href="/" class="logo logo-dark text-center">
                <span class="logo-sm">
                    <img src="../assets/images/logo-sm.png" alt="" height="22">
                </span>
                <span class="logo-lg">
                    <img src="../assets/images/logo-dark.png" alt="" height="20">
                </span>
            </a>

            <a href="/" class="logo logo-light text-center">
                <span class="logo-sm">
                    <img src="../assets/images/logo-sm.png" alt="" height="22">
                </span>
                <span class="logo-lg">
                    <img src="../assets/images/logo-light.png" alt="" height="20">
                </span>
            </a>
        </div>

      
        <div class="clearfix"></div>
      </div>
    </div>
      <div class="topnav">
          <div class="container-fluid" style="padding: 0 15px;width: 90%;min-width: 1000px;">
              <nav class="navbar navbar-light navbar-expand-lg topnav-menu">

                  <div class="collapse navbar-collapse active" id="topnav-menu-content">
                      <ul class="navbar-nav active">
                          <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle arrow-none" href="javascript:void(0)" id="topnav-apps" aria-haspopup="true" aria-expanded="false">
                                  <!--<i class="fe-grid mr-1"></i>--> <div class="lang" v-html="lan.service1"></div> <div class="arrow-down"></div>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="topnav-apps" >
                                  <div class="dropdown" v-for="(item, index) in creis_language_data.menu_offices"  :key="index">  
                                        <a  :href="goto(item['name_'+cur_lan],item['code'],item['name_en'],'',item['name_jp'],item['name_en'])" class="dropdown-item" v-if="item.lv2==undefined"> {{item["name_"+cur_lan]}}</a>
                          
                                        <a v-if="item.lv2!=undefined " class="dropdown-item dropdown-toggle arrow-none" :href="goto(item['name_'+cur_lan],item['code'],item['name_en'],'',item['name_jp'],item['name_en'])" :id="'topnav-'+item['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                            {{item["name_"+cur_lan]}} <div class="arrow-down"></div>
                                        </a>
                                        <div  v-if="item.lv2!=undefined " class="dropdown-menu"  :aria-labelledby="'topnav-'+item['name_'+cur_lan]" >
                                            <div  class="dropdown" v-for="(item2, index2) in item.lv2" :key="index2">
                                                <a :href="goto(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item2['name_jp'],item2['name_en'])" class="dropdown-item" v-if="item2.lv3==undefined">{{item2["name_"+cur_lan]}}</a>
                                            
                                                <a  v-if="item2.lv3!=undefined" class="dropdown-item dropdown-toggle arrow-none" :href="goto(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item2['name_jp'],item2['name_en'])" :id="'topnav-'+item2['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                                    {{item2["name_"+cur_lan]}} <div class="arrow-down"></div>
                                                </a>
                                                <div  v-if="item2.lv3!=undefined" class="dropdown-menu"  :aria-labelledby="'topnav-'+item2['name_'+cur_lan]">
                                            
                                                    <a :href="goto(item3['name_'+cur_lan],item3['code'],item['name_en'],item3['name_en'],item3['name_jp'],item3['name_en'])" class="dropdown-item"  v-for="(item3, index3) in item2.lv3" :key="index3" >{{item3["name_"+cur_lan]}}</a>

                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                  
                                  </div>
                                
                              </div>
                          </li>

                          <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle arrow-none" href="javascript:void(0)" id="topnav-ui" aria-haspopup="true" aria-expanded="false">
                                  <!--<i class="fe-briefcase mr-1"></i>--> <div class="lang" v-html="lan.service2"></div> <div class="arrow-down"></div>
                              </a>
                                 <div class="dropdown-menu" aria-labelledby="topnav-ui" >
                                  <div class="dropdown" v-for="(item, index) in creis_language_data.menu_industrial"  :key="index">  
                                        <a  :href="goto_id(item['name_'+cur_lan],item['code'],item['name_en'],'',item['code'],'',item['name_en'],item['name_jp'])" class="dropdown-item" v-if="item.lv2==undefined"> {{item["name_"+cur_lan]}}</a>
                          
                                        <a v-if="item.lv2!=undefined " class="dropdown-item dropdown-toggle arrow-none" :href="goto_id(item['name_'+cur_lan],item['code'],item['name_en'],'',item['code'],'',item['name_en'],item['name_jp'])" :id="'topnav-'+item['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                            {{item["name_"+cur_lan]}} <div class="arrow-down"></div>
                                        </a>
                                        <div  v-if="item.lv2!=undefined " class="dropdown-menu"  :aria-labelledby="'topnav-'+item['name_'+cur_lan]" >
                                            <div  class="dropdown" v-for="(item2, index2) in item.lv2" :key="index2">
                                                <a :href="goto_id(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item2['name_en'],item2['name_jp'])" class="dropdown-item" v-if="item2.lv3==undefined">{{item2["name_"+cur_lan]}}</a>
                                            
                                                <a  v-if="item2.lv3!=undefined" class="dropdown-item dropdown-toggle arrow-none" :href="goto_id(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item2['name_en'],item2['name_jp'])" :id="'topnav-'+item2['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                                    {{item2["name_"+cur_lan]}} <div class="arrow-down"></div>
                                                </a>
                                                <div  v-if="item2.lv3!=undefined" class="dropdown-menu"  :aria-labelledby="'topnav-'+item2['name_'+cur_lan]">
                                            
                                                    <a :href="goto_id(item3['name_'+cur_lan],item3['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item3['name_en'],item3['name_jp'])" class="dropdown-item"  v-for="(item3, index3) in item2.lv3" :key="index3" >{{item3["name_"+cur_lan]}}</a>

                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                  
                                  </div>
                                
                              </div>
                          </li>

                          <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle arrow-none" href="javascript:void(0)" id="topnav-components" aria-haspopup="true" aria-expanded="false">
                                  <!--<i class="fe-layers mr-1"></i>--> <div class="lang" v-html="lan.service3"></div> <div class="arrow-down"></div>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="topnav-components" >
                                  <div class="dropdown" v-for="(item, index) in creis_language_data.menu_retail"  :key="index">  
                                        <a  :href="goto_rs(item['name_'+cur_lan],item['code'],item['name_en'],'',item['code'],'',item['name_en'],item['name_jp'])" class="dropdown-item" v-if="item.lv2==undefined"> {{item["name_"+cur_lan]}}</a>
                          
                                        <a v-if="item.lv2!=undefined " class="dropdown-item dropdown-toggle arrow-none" :href="goto_rs(item['name_'+cur_lan],item['code'],item['name_en'],'',item['code'],'',item['name_en'],item['name_jp'])" :id="'topnav-'+item['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                            {{item["name_"+cur_lan]}} <div class="arrow-down"></div>
                                        </a>
                                        <div  v-if="item.lv2!=undefined " class="dropdown-menu"  :aria-labelledby="'topnav-'+item['name_'+cur_lan]" >
                                            <div  class="dropdown" v-for="(item2, index2) in item.lv2" :key="index2">
                                                <a :href="goto_rs(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item2['name_en'],item2['name_jp'])" class="dropdown-item" v-if="item2.lv3==undefined">{{item2["name_"+cur_lan]}}</a>
                                            
                                                <a  v-if="item2.lv3!=undefined" class="dropdown-item dropdown-toggle arrow-none" :href="goto_rs(item2['name_'+cur_lan],item2['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item2['name_en'],item2['name_jp'])" :id="'topnav-'+item2['name_'+cur_lan]" aria-haspopup="true" aria-expanded="false">
                                                    {{item2["name_"+cur_lan]}} <div class="arrow-down"></div>
                                                </a>
                                                <div  v-if="item2.lv3!=undefined" class="dropdown-menu"  :aria-labelledby="'topnav-'+item2['name_'+cur_lan]">
                                            
                                                    <a :href="goto_rs(item3['name_'+cur_lan],item3['code'],item['name_en'],item2['name_en'],item['code'],item2['code'],item3['name_en'],item3['name_jp'])" class="dropdown-item"  v-for="(item3, index3) in item2.lv3" :key="index3" >{{item3["name_"+cur_lan]}}</a>

                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                  
                                  </div>
                                
                              </div>
                          </li>
                        
                        
                          <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle arrow-none" href="/download_file" id="topnav-dashboard">
                                  <!--<i class="fe-airplay mr-1"></i>--> <div class="lang" v-html="lan.report"></div> 
                              </a>

                          </li>
                           <li class="nav-item dropdown" >
                              <a class="nav-link dropdown-toggle arrow-none" href="/download_video" id="topnav-dashboard">
                                  <!--<i class="fe-airplay mr-1"></i>--> <div class="lang" v-html="lan.video"></div> 
                              </a>

                          </li>
                          <li class="nav-item dropdown">
                              <a class="nav-link dropdown-toggle arrow-none" href="/download_data" id="topnav-dashboard">
                                  <!--<i class="fe-airplay mr-1"></i>--> <div class="lang" v-html="lan.data_download"></div>
                              </a>

                          </li>
                          
                      </ul> <!-- end navbar-->
                  </div> <!-- end .collapsed-->
                  
                  <button type="button" onclick="location.href='/userApply'" class="btn btn-blue waves-effect waves-light market-data-btn" v-if="show_btn" style="margin-right: 15px;float:right"><div class="lang" v-html="lan.user_apply_btn"></div></button>
                  <div class="faq"  v-show="route_name=='MarketArea'" @click="showhelp('office')"><i class="fe-help mr-1"></i> <div class="lang" v-html="lan.show_help"></div></div>
                  
                  <div class="faq"  v-show="route_name=='MarketAreaID'" @click="showhelp('industrial')"><i class="fe-help mr-1"></i> <div class="lang" v-html="lan.show_help"></div></div>
                  
                  <div class="faq"  v-show="route_name=='MarketAreaRS'" @click="showhelp('retail')"><i class="fe-help mr-1"></i> <div class="lang" v-html="lan.show_help"></div></div>
                  <a  href="/faq" class="faq"  v-show="email!=''" ><i class="fe-help mr-1"></i> <div class="lang" v-html="lan.faq"></div></a>
                  <a href="/super_admin" class="super-admin"  v-show="groups=='admin'"><i class="fe-user mr-1"></i> <div class="lang" v-html="lan.super_admin"></div></a>
                  
              </nav>
          </div> <!-- end container-fluid -->
      </div>
      <transition name="fade">
          <div v-show="isPopupHelpArea" class="modal popup-modal">
            <div class="modal-dialog">
              <div class="popup modal-content help-box">
                <div class="modal-header">
                  <button type="button" class="close" @click="isPopupHelpArea = false">
                    <span>×</span>
                  </button>
                </div>
                <div class="modal-body help-body" v-if="isPopupHelpArea">
               
                <div class="area-btn">
                <div v-html="current_help"></div>
                </div>
                </div>
              </div>
            </div>
            <div class="popup-bg" @click="isPopupHelpArea = false"></div>
          </div>
        </transition>
        <transition name="fade">
          <div v-show="isPopupForgotPassword" class="modal popup-modal resetpasswod">
            <div class="modal-dialog">
              <div class="popup modal-content help-box">
                <div class="modal-header">
                  <button type="button" class="close" @click="isPopupForgotPassword = false">
                    <span>×</span>
                  </button>
                </div>
                <div class="modal-body" style="background: #f5f6f8;" v-if="isPopupForgotPassword">
               
                <div class="area-btn ">
                    <h3>{{lan.edit_password}}</h3><br>
                    <div class="line ubox">
                        <div class="line"><div class="left-box"><div class="lang" v-html="lan.new_password"></div></div>
                        <div class="right-box"><div class="show-password"><input v-model="new_password" :type="inputtype" >
                            <div class="conceal "  v-show="showpassword==0" @click="showpassword=1;inputtype='text'" style="position: absolute; top: 15px; z-index: 2; right: 10px; width: 30px; height: 30px; background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAkxJREFUaEPt2E+oT1EQB/DPW9lQVpTyZ4UoEimxkIUNlsiCsmBrI6UUFqRs7MTGv3qFlBVlQ9goLCis/IkiK8RO0dS9r9vt/n3HS7fu1On8XufMnPnOd87cOW/CwGVi4P4bAfxvBkcGRgYSIzCmUGIAk9VHBpJDmGhgZCAL4GKsQ8xLsjl+x/iDd4XxCR/xDB8SCUhuJbZiF3Zjdk9nfuI6buBeT92p7dNJoXkFpzdN9+CS3uMCmK99bPYFsAXnsbTPIT32vsUR3Oqq0wfAPlxpMXwbDxF5nud6zItKYxua2DuFY11AdAVwFodrDN5FjGv41uXQbM8K7MzGygq9OwigjdIFwBssq7DyACcRc1n2Ygc24DceIfL8Yo0353CoYu0zFjQhaAPwGssrDITjJ2oMR1WJyFZJlM4ot1WyB5cwq7T4EqvqQDQBOI2jJcX32F8T9dj6FGtbWL+ZVbG6bcHUxtJi+HGmSqEOwHo8KSn8wvYG5w/iQlvOZutREOLO1MkXzC8trsaLskIdgB+YU9ockb/ccOhVRO7nkt+PqOvxsTteWGtjYQ2el876jrldAEwi8rEoUZujEjVJtAvRRuQSleVV9sdm3C+sRWld2GLvQMWlD9aCvSmpYmDwAALdv06hqErFqjWjKRQABn+JA8Sgy2h+SQb9IctBDLqVyEEMupnLQQy6nc5BDPpBk4MY9JOy/PUf5KO+qoUZ7L9VWvqxmV9ue5HNvAeJJ4wAEgOYrD4ykBzCRAMjA4kBTFYfGUgOYaKBkYHEACar/wVzOJ4xdD9a1gAAAABJRU5ErkJggg==&quot;); background-size: 100% 100%; cursor: pointer;" tabindex="0" id="conceal"></div>
                                <div class="conceal " @click="showpassword=0;inputtype='password'" style="position: absolute; top: 15px; z-index: 2; right: 10px; width: 30px; height: 30px; background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABJBJREFUaEPtV91rHFUU/51JTKrVYNOZ2dkmymZn1bSKD7HiR0Da+qIo+FHiZ+ujWiEiiC8WNX5AKfqkFUUfWm3R0ogff4Daom1RKRYVsXFnm8a6O7MzKWrTxtrsHLmT3XZ3s7PZ2ckikbkwMMw953d/5/zOPfcOYZEPWuT8EQXwXysYKRApEDIDUQmFTGBo90iB0CkMCRApEDKBod3/XwroMWUYhHsBvGeY9o7Q6VlAgGRMfoqI7mLwvozpjJSgKxTQNSUPQPEmGU8alv3GAnJoGioVVzcw885ZWnwiYzrLfQJQXwP46fOTvDZtOnubXnkBHPVY7BqQ+2MJiglbMjn72ZoBiI+6pn4O8LqiwbRh2hctAI+mIXRN+RNAl5d95l0Zy9lYDjZnE/f2dnV3znSmASwrGo4Zpn1V0wxCOOqacgjAQLGkf+900f+zbU/VDUBM9sWVWyTGvjLDKdelwaP5/A8h+DTsmtTkOwj0EYAlJac2yV05lp38pRrEt40mNfUJAr9ZES1jc9qytwIoNMwmgOEaoH0iJu8goofL3Zj5oYzlfFgLqu45kNLkEQa9UOV4kNjdmrYmPwvAbV5TPa7eA+YtACrKlYnWZ3L5j/0A6gaga8oeAEM+zt8BNFqANDpumuPzMqxhkNC0RBvcIYDFGtfPNeFj01LHqmw2ezpwAKme7l4utP3m7X7gqES0iZlfAbC6ahOdYmBUPFTAmGHbogH4jitisWSB3H4ChsTDwNIq4yMMdBDQ530nftTIOe8GDkCPK5vBEIQFysuGmX8+1d3dxR3tjwN8H4DrfEBPAzQO8DEAaRBcMPUBnGSgj+YSLsF8RcSfStTxfsE9eyeA7cW1vzDM/K3BA9DknwC6WjgW2L1x3Jr8phxEjyu3AfQImB8QETZTQgBcBt6ChN2ZrP11CSORSCxp//uUU1KHJAyks/b3DW/ilKrexBIf8HIP+jZt5m/wI6hrimhtsxuPsR/ElwJ0OYBLqnxOAjwBkARgZXFu2DDtbbWwda3iVrDNMO3hhgNIavIIFbsPg18svzyVg6xSlIvPtEGclIIULjPtC/YCM+JdHIgXcqcIBNN0ZuL48b9OiPeUJq9h0JezOPy2YTqbagagqjdD4v3FuZOGaXuncfWoKb2uKbcDeF2sB+LVRs4RJ+KckYrLA8xUmjtkmHbFBq/l09/Ts/xs4R/HmyMcMHL2oL+65681hNr3Mt/aTWmaMgMsrdci9ZhyPwi7Z5NJ7xhW/jE/MuXfdU05AuBKAFOGaVeX2jnTlKaILrUHjD8kF2t/te3DDSnQCAlho2vycwC9VLT3redqPD2ufgDmB724Wbo2Y1nnbpvVtuKsaMdMwu9W3Gz38NZJxuSdRLShWM/rDNMp1nb9FJS3aCLamM7ldzWatAVWoOykZilmWJb4IZp36CvUu+HyJ54CdZrEvEAh+reHra9QB8F4htk97Nep/Deosh1Ey0B41cjmS92mEc4VNqFKKPBqLXCIAmhBUgNBRgoESlcLjCMFWpDUQJCRAoHS1QLjSIEWJDUQZKRAoHS1wHjRK/AvYGKJQLT2guEAAAAASUVORK5CYII=&quot;); background-size: 100% 100%; cursor: pointer;" tabindex="0" v-show="showpassword==1" id="conceal2"></div>
                            
                        </div><button class="btn save" @click="updatepassword()"><div class="lang" v-html="lan.save"></div></button> </div>
                        <div class="lang contract-msg" v-html="lan.contract_admin_msg"></div>
                    </div>
                     
                    </div>  
                    </div>
                </div>
              </div>
            </div>
            <div class="popup-bg" @click="isPopupForgotPassword = false"></div>
          </div>
        </transition>
    </div>
</template>

<script>
import {check_login,getNdate} from '../components/common'
import axios from 'axios'
export default {
  name: 'Headers',
  props: {
    viewParams: {
    cur_menu: {
      type: String,
      require: true,
      default: ''
    },
    },
  },
  data() {
    return {
      creis_language_data: {},
      menu_data:[],
      cur_lan:localStorage.getItem('cur_lan') !="en" ? "jp":"en",
      email:"",
      username:'',
      groups:'',
      cbredataUser:0,
      isPopupHelpArea:false,
      current_help:'',
      lan:[],
      route_name:'',
      show_btn:0,
      is_adduser:0,
      uinfo:{},
      isPopupForgotPassword:0,
      new_password:'',
      inputtype:'password',
      showpassword:0,
    }
  },
  mounted() {
      this.route_name=this.$route.name;
      console.log(this.cur_lan);
      //localStorage.removeItem("uinfo");
      if(check_login()){
        this.groups=localStorage.getItem("groups");
        if(this.cur_lan!=localStorage.getItem('cur_lan')){
            localStorage.setItem('cur_lan',localStorage.getItem('cur_lan')!='en' ? 'jp':'en');
            this.cur_lan=localStorage.getItem('cur_lan');
            window.location.href='/';
        }
        this.cur_lan=localStorage.getItem('cur_lan');
        this.email=localStorage.getItem("email");
        this.creis_language_data=JSON.parse(localStorage.getItem('creis_language_data'));
        this.lan=this.creis_language_data['menu_data_'+this.cur_lan];
    
        this.getuinfo();
        
    }else{
        if((localStorage.getItem('cur_lan') =='null' || localStorage.getItem('cur_lan') ==null ) && this.cur_lan!=localStorage.getItem('cur_lan')){
            localStorage.setItem('cur_lan',localStorage.getItem('cur_lan')!='en' ? 'jp':'en');
            this.cur_lan=localStorage.getItem('cur_lan');
            window.location.href='/';
        }
    }
    
  },methods:{
    showhelp(type){
      this.current_help=this.lan['help_'+type];
      this.isPopupHelpArea=1;
    },
    showintro:function(){
         var introJS = require('intro.js')
      introJS().setOptions({
          steps: [{
            title: 'Welcome',
            intro: 'Hello World! 👋'
          },
          {
            title: 'Step 1',
            element: document.querySelector('.first'),
            intro: 'Step 1'
          },
          {
            title: 'step 2',
            element: document.querySelector('.two'),
            intro: 'step 2'
          },
          {
            title: 'step 3',
            element: document.querySelector('.three'),
            intro: 'step 3'
          }]
        }).start();
    },
    goto:function(area_name,area,area_name_en,child_area_name_en,area_name_jp,area_name_en2){
        return '/marketArea?area_name='+area_name+'&area_name_en='+area_name_en+'&area_name_jp='+area_name_jp+'&area_name_en2='+area_name_en2+'&child_area_name_en='+child_area_name_en+'&area='+area;
    },
    goto_id:function(area_name,area,area_name_en,child_area_name_en,parent_area,child_area,area_name_en2,area_name_jp){
        if(area!='21690'){
            return '/marketAreaID?area_name='+area_name+'&area_name_en='+area_name_en+'&area_name_jp='+area_name_jp+'&area_name_en2='+area_name_en2+'&child_area_name_en='+child_area_name_en+'&area='+area+'&parent_area='+parent_area+'&child_area='+child_area;
        }else{
            return "####"
        }
    },
    goto_rs:function(area_name,area,area_name_en,child_area_name_en,parent_area,child_area,area_name_en2,area_name_jp){
        return '/marketAreaRS?area_name='+area_name+'&area_name_en='+area_name_en+'&area_name_jp='+area_name_jp+'&area_name_en2='+area_name_en2+'&child_area_name_en='+child_area_name_en+'&area='+area+'&parent_area='+parent_area+'&child_area='+child_area;
    },
    gotourl:function(url){
        location.href=url;
    },
    logout:function (){
        localStorage.removeItem('id_token');
        localStorage.removeItem('groups');
        localStorage.removeItem('name');
        localStorage.removeItem('uinfo');
        localStorage.removeItem('from_site');
        localStorage.removeItem('email');

        setTimeout(()=>{
        window.location.href = 'https://auth.creis.jp/login?token=logout';//'https://auth.cbredata.com/login?client_id=1gcmfopbf7qtttffm228f52657&response_type=token&redirect_uri=https://cbredata.com/jp/index.php';                       
        },500)
    },
    updatepassword:function(){
        //this.isLoading=true; 
        var reg=/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>/?]).{8,}$/
        if(!reg.test(this.new_password)){
            alert(this.lan.password_error)
            return false;
        }
        axios
        .post('creisResetPassword',{active_user:this.uinfo['メールアドレス'],new_password:this.new_password,key:'7zc4TcOOd5Z6VWHowTznrEWRqgtZLeqNQKm3+cmE'} )
            .then((response) => {
            
            if(response.data.status){
              alert(this.lan.update_password_success)
              console.log('save success'); 
              //window.location.reload();//reload the page
              }
            
            this.isPopupForgotPassword = false
            
            })
            .catch(error => {
        
            //this.isLoading = false
            console.log(error)
            });
        
     
    },
    getFrontVisit:function(){
        let area_name=this.$route.query.area_name_jp != undefined ? this.$route.query.area_name_jp : '';
        axios
        .post('get_front_page_visit',{area:area_name,path:window.location.pathname} )
            .then((response) => {
            console.log(response.data);
            })
            .catch(error => {
        
            //this.isLoading = false
            console.log(error)
            });
    },
    change_language:function(lan){
       
      if(this.route_name=="UserApply" && localStorage.getItem('cur_step')>1){
        console.log("no change");
      }else{
      localStorage.setItem('cur_lan',lan);
      this.cur_lan=lan;
      if(this.route_name=="Home"){
        window.location.href='/';

      }else{
        window.location.reload();
      }
      
      }
    },getuinfo:function(){
        var that=this;
        setTimeout(() => {
            var uinfo=localStorage.getItem("uinfo");
            if(uinfo!=undefined && uinfo!=null && uinfo!=""){
                uinfo=JSON.parse(uinfo);
                that.uinfo=uinfo;
                that.cbredataUser=uinfo.group=='cbredata user' ? 1:0;
                that.no_access=0;
                    
                that.username=uinfo['担当者・姓']!=null && uinfo['担当者・姓']!='' ? uinfo['担当者・姓']+' '+uinfo['担当者・名']:localStorage.getItem("name");
                localStorage.setItem("name",that.username) 
                if(uinfo['group']=='cbredata user'){
                    localStorage.setItem("company_name",'CBRE');
                }else{
                    localStorage.setItem("company_name",uinfo['会社名']);   
                }
                that.is_adduser=uinfo['親ID']==0 && (uinfo['インダスマーケット'] || uinfo['オフィスマーケット'] || uinfo['リテールマーケット']) && (uinfo['step']==6.1 || uinfo['step']==7) && uinfo['状態']==1 ?1:0;
                
                if((uinfo['step']<6.1 || uinfo['契約期限 終了日']<getNdate()) && uinfo['親ID']==0 && that.cbredataUser==0 && that.groups!='admin' && that.route_name!="UserApply"){
                    that.show_btn=1;
                }
                that.getFrontVisit()
            }else{
                that.getuinfo();
            } 
        }, 1500);
    }
  }
}
</script>

<style lang="scss" scoped>
.irs-hidden-input {
  opacity: 0;
}
.user-image{    width: 20px;
    height: 15px;}
.table-responsive th, span{width: 95px;}
.faq{margin-right: 20px; }
.super-admin{float:right; font-weight:bolder; cursor: pointer;color:#6D767E}
.faq{float:right; font-weight:normal;cursor: pointer; color:#6D767E}
.dropdown-toggle::after{
    display: none !important
}
.popup-modal {
    display: block;
  }
  .popup-bg {
    background: rgba(0, 0, 0, .25);
    height: 100vh;
    left: 0;
    top: 0;
    position: fixed;
    width: 100vw;
    z-index: 9;
  }

  .popup {
    background: #fff;
    border-radius: .15rem;
    box-shadow: 0 .15rem .5rem rgba(0, 0, 0, .25);
    left: 50% !important;
    min-height: 200px;
    width: 850px;
    position: fixed;

    transform: translateX(-50%) !important;
    z-index: 16;
   
  }
.modal-body{
overflow: auto;
}
.help-body{overflow: auto;
    max-height: 90vh; 
}
  .popup iframe {
    width: 100%;
  }
 .resetpasswod{
    top:250px;
    .line{margin: 0;line-height: 60px;
    width: 98%;
    display: table;
        margin-top: -1px;
        input{line-height: 40px;border: 1px solid #ccc;padding: 0 5px;}
    }
    .line .left-box{   
        font-size: 20px;
    line-height: 50px;
        color: #000;   min-height: 40px; padding: 8px;
     }
    .left-box{display: inline-block;margin-right: 20px; float: left;}
    .title,h4{color:#003f2d;}
    .right-box{margin-left:-1px;width: 60%;    min-height: 40px; float: left;  padding: 5px 10px;
        }
    .content{background: #fff;padding: 20px;position: relative;}
    .btn{color:#fff;background: #042a2d;margin:10px 20px;}
    .btn-bottom{margin:50px auto 0 auto;}
    .show-password{    position: relative;
    display: inline-block;}
    .contract-msg{line-height: 20px;padding: 10px;}
 }
 @media screen and (max-width: 1240px) {
  .faq{display: none;}
}
 @media screen and (max-width: 1100px) {
  .super-admin{display: none;}
}
</style>